const API_BASE = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');
export class ApiError extends Error {
    status;
    errors;
    constructor(message, status, errors = []) {
        super(message);
        this.status = status;
        this.errors = errors;
    }
}
export const apiUrl = (path) => `${API_BASE}${path}`;
export async function apiRequest(path, options = {}) {
    const isFormData = options.body instanceof FormData;
    const response = await fetch(apiUrl(path), {
        ...options,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            ...(!isFormData && options.body ? { 'Content-Type': 'application/json' } : {}),
            ...options.headers,
        },
    });
    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new ApiError(payload.error || payload.errors?.[0] || 'Ocurrió un error. Intentá nuevamente.', response.status, payload.errors || []);
    }
    if (response.status === 204)
        return undefined;
    return response.json();
}
export async function copyText(value) {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
    }
    const textArea = document.createElement('textarea');
    textArea.value = value;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    textArea.remove();
}
